import { Link } from '@tanstack/react-router';
import { Store } from 'lucide-react';
import { Empty, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from 'app/javascript/components/ui/empty';
import { Button } from 'app/javascript/components/ui/button';
import { ROUTES } from 'app/javascript/constants/routes';

export default function StoreEmptyState({ slug }: { slug: string }) {
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-2xl items-center px-4 py-16 sm:px-6">
      <Empty className="w-full border-0 bg-transparent">
        <EmptyHeader>
          <EmptyMedia variant="icon">
            <Store />
          </EmptyMedia>
          <EmptyTitle>Esta academia ainda não tem loja</EmptyTitle>
          <EmptyDescription>
            Os produtos desta equipe ainda não estão disponíveis por aqui.
          </EmptyDescription>
        </EmptyHeader>
        <Button asChild variant="outline">
          <Link to={ROUTES.COMPANY_DETAILS} params={{ slug }}>
            Voltar para a academia
          </Link>
        </Button>
      </Empty>
    </div>
  );
}
